import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	({ palette, spacing }) => ({
		root: {},
		checkbox: {
			color: palette.primary.main,
			padding: spacing(1.25),
			alignSelf: 'flex-start',
			'& svg': {
				width: spacing(3.2),
				height: spacing(3.2),
			},
		},
		control: {
			margin: 0,
		},
		label: {
			textShadow: ({ shadow }) => (shadow ? palette.textShadow : null),
			display: 'flex',
			alignItems: 'center',
		},
		checkedIcon: {},
	}),
	{ name: 'Questions-AnswerTypes-Checkbox' },
)

export default useStyles
